import React from "react";
import "./CardLoader.scss";
import SkeletonLoader from "../SkeletonLoader/SkeletonLoader";
import ClassNames from "classnames";

interface CardLoaderProps {
  className?: string;
  multiply?: number;
}

const CardLoader = (props: CardLoaderProps): JSX.Element[] => {
  const { multiply = 1, className } = props;

  const classNameWrapper = ClassNames("card-loader-wrap", className);

  return Array.from({ length: multiply }, (_, index) => (
    <div className={classNameWrapper} key={index}>
      <SkeletonLoader
        wrapperClassName="card-loader-img"
        height={"140px"}
        width={"75%"}
      />
      <SkeletonLoader
        wrapperClassName="card-loader-text"
        height={"40px"}
        width={"75%"}
      />
    </div>
  ));
};

export default CardLoader;
